import { setupHandleError } from "error-logging!sofe";
export const handleError = setupHandleError("notifications-ui");
